{
  "HELP_CENTER": {
    "TITLE": "Centar za pomoć",
    "NEW_PAGE": {
      "DESCRIPTION": "Kreirajte portale centra za pomoć za samostalnu podršku vašim korisnicima. Pomozite im da brzo pronađu odgovore, bez čekanja. Pojednostavite upite, povećajte efikasnost agenata i podignite kvalitet korisničke podrške.",
      "CREATE_PORTAL_BUTTON": "Kreiraj portal"
    },
    "NEW_ARTICLE_PAGE": {
      "PLACEHOLDER_TITLE": "Bez naslova"
    },
    "HEADER": {
      "FILTER": "Filtrirajte prema",
      "SORT": "Sortirajte prema",
      "LOCALE": "Lokal",
      "SETTINGS_BUTTON": "Podešavanja",
      "NEW_BUTTON": "Novi članak",
      "DROPDOWN_OPTIONS": {
        "PUBLISHED": "Objavljeno",
        "DRAFT": "Draft",
        "ARCHIVED": "Arhivirano"
      },
      "TITLES": {
        "ALL_ARTICLES": "Svi članci",
        "MINE": "Moji članci",
        "DRAFT": "Draft članci",
        "ARCHIVED": "Arhivirani članci"
      },
      "LOCALE_SELECT": {
        "TITLE": "Izaberi lokal",
        "PLACEHOLDER": "Izaberi lokal",
        "NO_RESULT": "Lokal nije pronađen",
        "SEARCH_PLACEHOLDER": "Pretraži lokal"
      }
    },
    "EDIT_HEADER": {
      "ALL_ARTICLES": "Svi članci",
      "PUBLISH_BUTTON": "Objavite",
      "MOVE_TO_ARCHIVE_BUTTON": "Premesti u arhivu",
      "PREVIEW": "Pregledajte",
      "ADD_TRANSLATION": "Dodajte prevod",
      "OPEN_SIDEBAR": "Otvorite bočnu traku",
      "CLOSE_SIDEBAR": "Zatvorite bočnu traku",
      "SAVING": "Čuvanje...",
      "SAVED": "Sačuvano"
    },
    "ARTICLE_EDITOR": {
      "IMAGE_UPLOAD": {
        "TITLE": "Dodaj sliku",
        "UPLOADING": "Dodavanje...",
        "SUCCESS": "Slika je uspešno otpremljena",
        "ERROR": "Greška prilikom otpremanja slike",
        "UN_AUTHORIZED_ERROR": "Nemate ovlašćenje da otpremate slike",
        "ERROR_FILE_SIZE": "Veličina slike treba da bude manja od {size}MB",
        "ERROR_FILE_FORMAT": "Format slike treba da bude jpg, jpeg ili png",
        "ERROR_FILE_DIMENSIONS": "Dimenzije slike treba da budu manje od 2000 x 2000"
      },
      "ANCHOR": {
        "BUTTON": "Уметни сидро",
        "TITLE": "Уметни сидро",
        "SUBMIT": "Уметни",
        "PLACEHOLDER": "anchor-name"
      }
    },
    "ARTICLE_SETTINGS": {
      "TITLE": "Podešavanja članka",
      "FORM": {
        "CATEGORY": {
          "LABEL": "Kategorija",
          "TITLE": "Izaberi kategoriju",
          "PLACEHOLDER": "Izaberi kategoriju",
          "NO_RESULT": "Nije pronađena kategorija",
          "SEARCH_PLACEHOLDER": "Pretraži kategoriju"
        },
        "AUTHOR": {
          "LABEL": "Autor",
          "TITLE": "Izaberi autora",
          "PLACEHOLDER": "Izaberi autora",
          "NO_RESULT": "Nije pronađen autor",
          "SEARCH_PLACEHOLDER": "Pretraži autora"
        },
        "META_TITLE": {
          "LABEL": "Meta naslov",
          "PLACEHOLDER": "Dodaj meta naslov"
        },
        "META_DESCRIPTION": {
          "LABEL": "Meta opis",
          "PLACEHOLDER": "Dodajte meta opis za bolje SEO rezultate..."
        },
        "META_TAGS": {
          "LABEL": "Meta oznake",
          "PLACEHOLDER": "Dodajte meta oznake odvojene zarezom..."
        }
      },
      "BUTTONS": {
        "ARCHIVE": "Arhiviraj članak",
        "DELETE": "Obriši članak"
      }
    },
    "ARTICLE_SEARCH_RESULT": {
      "UNCATEGORIZED": "Nekategorisano",
      "SEARCH_RESULTS": "Rezultati pretrage za {query}",
      "EMPTY_TEXT": "Pretražite članke da biste ih umetnuli u odgovore.",
      "SEARCH_LOADER": "Pretraga...",
      "INSERT_ARTICLE": "Umetni",
      "NO_RESULT": "Članci nisu pronađeni",
      "COPY_LINK": "Kopiraj link članka u privremenu memoriju",
      "OPEN_LINK": "Otvori članak u novoj kartici",
      "PREVIEW_LINK": "Pregledaj članak"
    },
    "PORTAL": {
      "HEADER": "Portali",
      "DEFAULT": "Predefinisano",
      "NEW_BUTTON": "Novi portal",
      "ACTIVE_BADGE": "aktivan",
      "CHOOSE_LOCALE_LABEL": "Izaberi lokal",
      "LOADING_MESSAGE": "Učitavanje portala...",
      "ARTICLES_LABEL": "članci",
      "NO_PORTALS_MESSAGE": "Nema dostupnih portala",
      "ADD_NEW_LOCALE": "Dodaj novi lokal",
      "POPOVER": {
        "TITLE": "Portali",
        "PORTAL_SETTINGS": "Podešavanja portala",
        "SUBTITLE": "Možete imati više portala koji mogu imati različite lokale za svaki portal.",
        "CANCEL_BUTTON_LABEL": "Otkaži",
        "CHOOSE_LOCALE_BUTTON": "Izaberi lokal"
      },
      "PORTAL_SETTINGS": {
        "LIST_ITEM": {
          "HEADER": {
            "COUNT_LABEL": "članci",
            "ADD": "Dodaj lokal",
            "VISIT": "Poseti sajt",
            "SETTINGS": "Podešavanja",
            "DELETE": "Izbriši"
          },
          "PORTAL_CONFIG": {
            "TITLE": "Podešavanja portala",
            "ITEMS": {
              "NAME": "Ime",
              "DOMAIN": "Prilagođeni domen",
              "SLUG": "Slug",
              "TITLE": "Naslov portala",
              "THEME": "Boja teme",
              "SUB_TEXT": "Podtekst portala"
            }
          },
          "AVAILABLE_LOCALES": {
            "TITLE": "Dostupni lokali",
            "TABLE": {
              "NAME": "Naziv lokala",
              "CODE": "Kod lokala",
              "ARTICLE_COUNT": "Broj članaka",
              "CATEGORIES": "Broj kategorija",
              "SWAP": "Zameni",
              "DELETE": "Izbriši",
              "DEFAULT_LOCALE": "Predefinisano"
            }
          }
        },
        "DELETE_PORTAL": {
          "TITLE": "Obriši portal",
          "MESSAGE": "Da li ste sigurni da želite da obrišete ovaj portal",
          "YES": "Da, obriši portal",
          "NO": "Ne, zadrži portal",
          "API": {
            "DELETE_SUCCESS": "Portal je uspešno obrisan",
            "DELETE_ERROR": "Greška prilikom brisanja portala"
          }
        }
      },
      "EDIT": {
        "HEADER_TEXT": "Izmeni portal",
        "TABS": {
          "BASIC_SETTINGS": {
            "TITLE": "Osnovne informacije"
          },
          "CUSTOMIZATION_SETTINGS": {
            "TITLE": "Prilagođavanje portala"
          },
          "CATEGORY_SETTINGS": {
            "TITLE": "Kategorije"
          },
          "LOCALE_SETTINGS": {
            "TITLE": "Lokali"
          }
        },
        "CATEGORIES": {
          "TITLE": "Kategorije u",
          "NEW_CATEGORY": "Nova kategorija",
          "TABLE": {
            "NAME": "Ime",
            "DESCRIPTION": "Opis",
            "LOCALE": "Lokal",
            "ARTICLE_COUNT": "Broj članaka",
            "ACTION_BUTTON": {
              "EDIT": "Izmeni kategoriju",
              "DELETE": "Obriši kategoriju"
            },
            "EMPTY_TEXT": "Nije pronađena nijedna kategorija"
          }
        },
        "EDIT_BASIC_INFO": {
          "BUTTON_TEXT": "Ažuriraj osnovna podešavanja"
        }
      },
      "ADD": {
        "CREATE_FLOW": {
          "BASIC": {
            "TITLE": "Informacije o centru za pomoć",
            "BODY": "Osnovne informacije o portalu"
          },
          "CUSTOMIZATION": {
            "TITLE": "Prilagođavanje centra za pomoć",
            "BODY": "Prilagodi portal"
          },
          "FINISH": {
            "TITLE": "Izvolite! 🎉",
            "BODY": "Sve je spremno!"
          }
        },
        "CREATE_FLOW_PAGE": {
          "BACK_BUTTON": "Nazad",
          "BASIC_SETTINGS_PAGE": {
            "HEADER": "Kreiraj portal",
            "TITLE": "Informacije o centru za pomoć",
            "CREATE_BASIC_SETTING_BUTTON": "Kreiraj osnovna podešavanja portala"
          },
          "CUSTOMIZATION_PAGE": {
            "HEADER": "Prilagođavanje portala",
            "TITLE": "Prilagođavanje centra za pomoć",
            "UPDATE_PORTAL_BUTTON": "Ažuriraj podešavanja portala"
          },
          "FINISH_PAGE": {
            "TITLE": "Gotovo!🎉 Sve je podešeno!",
            "MESSAGE": "Sada možete videti kreirani portal na stranici sa svim portalima.",
            "FINISH": "Idi na stranicu sa svim portalima"
          }
        },
        "LOGO": {
          "LABEL": "Logo",
          "UPLOAD_BUTTON": "Otpremi logo",
          "HELP_TEXT": "Ovaj logo će biti prikazan u zaglavlju portala.",
          "IMAGE_UPLOAD_SUCCESS": "Logo je uspešno otpremljen",
          "IMAGE_UPLOAD_ERROR": "Logo je uspešno obrisan",
          "IMAGE_DELETE_ERROR": "Greška prilikom brisanja logotipa"
        },
        "NAME": {
          "LABEL": "Ime",
          "PLACEHOLDER": "Naziv portala",
          "HELP_TEXT": "Naziv će se koristiti interno u javno dostupnim portalima.",
          "ERROR": "Ime je neophodno"
        },
        "SLUG": {
          "LABEL": "Slug",
          "PLACEHOLDER": "Slug portala za adrese",
          "ERROR": "Slug je obavezan"
        },
        "DOMAIN": {
          "LABEL": "Prilagođeni domen",
          "PLACEHOLDER": "Prilagođeni domen portala",
          "HELP_TEXT": "Dodajte samo ako želite da koristite prilagođeni domen za svoje portale. Npr: {exampleURL}",
          "ERROR": "Unesite važeći URL domena"
        },
        "HOME_PAGE_LINK": {
          "LABEL": "Veza početne stranice",
          "PLACEHOLDER": "Veza do početne stranice portala",
          "HELP_TEXT": "Link koji se koristi za povratak sa portala na početnu stranicu. Npr: {exampleURL}",
          "ERROR": "Unesite važeći URL početne stranice"
        },
        "THEME_COLOR": {
          "LABEL": "Boja teme portala",
          "HELP_TEXT": "Ova boja će se prikazivati kao boja teme portala."
        },
        "PAGE_TITLE": {
          "LABEL": "Naslov stranice",
          "PLACEHOLDER": "Naslov stranice portala",
          "HELP_TEXT": "Naslov stranice će se koristiti u javno dostupnom portalu.",
          "ERROR": "Naslov stranice je obavezan"
        },
        "HEADER_TEXT": {
          "LABEL": "Tekst zaglavlja",
          "PLACEHOLDER": "Tekst zaglavlja portala",
          "HELP_TEXT": "Tekst zaglavlja portala će se koristiti u javno dostupnom portalu.",
          "ERROR": "Tekst zaglavlja portala je obavezan"
        },
        "API": {
          "SUCCESS_MESSAGE_FOR_BASIC": "Portal je uspešno napravljen.",
          "ERROR_MESSAGE_FOR_BASIC": "Nije bilo moguće napraviti portal. Pokušajte ponovo.",
          "SUCCESS_MESSAGE_FOR_UPDATE": "Portal je uspešno ažuriran.",
          "ERROR_MESSAGE_FOR_UPDATE": "Portal nije moguće ažurirati. Pokušajte ponovo."
        }
      },
      "ADD_LOCALE": {
        "TITLE": "Dodaj novi lokal",
        "SUB_TITLE": "Ovim se dodaje novi lokal na vašu listu dostupnih prevoda.",
        "PORTAL": "Portal",
        "LOCALE": {
          "LABEL": "Lokal",
          "PLACEHOLDER": "Izaberi lokal",
          "ERROR": "Lokal je obavezan"
        },
        "BUTTONS": {
          "CREATE": "Kreiraj lokal",
          "CANCEL": "Otkaži"
        },
        "API": {
          "SUCCESS_MESSAGE": "Lokal je uspešno dodat",
          "ERROR_MESSAGE": "Lokal nije moguće dodati. Pokušajte ponovo."
        }
      },
      "CHANGE_DEFAULT_LOCALE": {
        "API": {
          "SUCCESS_MESSAGE": "Podrazumevani lokal je uspešno ažuriran",
          "ERROR_MESSAGE": "Podrazumevani lokal nije moguće ažurirati. Pokušajte ponovo."
        }
      },
      "DELETE_LOCALE": {
        "API": {
          "SUCCESS_MESSAGE": "Lokal je uspešno uklonjen sa portala",
          "ERROR_MESSAGE": "Lokal nije moguće ukloniti sa portala. Pokušajte ponovo."
        }
      }
    },
    "TABLE": {
      "404": "Nema članaka koji se poklapaju sa vašom pretragom 🔍",
      "LOADING_MESSAGE": "Učitavanje članaka...",
      "NO_ARTICLES": "Nema dostupnih članaka",
      "HEADERS": {
        "TITLE": "Naslov",
        "CATEGORY": "Kategorija",
        "READ_COUNT": "Pregledi",
        "STATUS": "Status",
        "LAST_EDITED": "Poslednje izmenjeno"
      },
      "COLUMNS": {
        "BY": "od strane",
        "AUTHOR_NOT_AVAILABLE": "Autor nije dostupan"
      }
    },
    "EDIT_ARTICLE": {
      "LOADING": "Učitavanje članka...",
      "TITLE_PLACEHOLDER": "Ovde ide naslov članka",
      "CONTENT_PLACEHOLDER": "Ovde pišite vaš članak",
      "API": {
        "ERROR": "Greška prilikom čuvanja članka"
      }
    },
    "PUBLISH_ARTICLE": {
      "API": {
        "ERROR": "Greška prilikom objavljivanja članka",
        "SUCCESS": "Članak je uspešno objavljen"
      }
    },
    "ARCHIVE_ARTICLE": {
      "API": {
        "ERROR": "Greška prilikom arhiviranja članka",
        "SUCCESS": "Članak je uspešno arhiviran"
      }
    },
    "DRAFT_ARTICLE": {
      "API": {
        "ERROR": "Greška prilikom prebacivanja članka u Draft",
        "SUCCESS": "Članak je uspešno prebačen u Draft"
      }
    },
    "DELETE_ARTICLE": {
      "MODAL": {
        "CONFIRM": {
          "TITLE": "Potvrdite brisanje",
          "MESSAGE": "Da li ste sigurni da želite da obrišete članak?",
          "YES": "Da, obriši",
          "NO": "Ne, zadrži ga"
        }
      },
      "API": {
        "SUCCESS_MESSAGE": "Članak je uspešno obrisan",
        "ERROR_MESSAGE": "Greška prilikom brisanja članka"
      }
    },
    "CREATE_ARTICLE": {
      "ERROR_MESSAGE": "Dodajte naslov i sadržaj članka da biste mogli da ažurirate podešavanja"
    },
    "SIDEBAR": {
      "SEARCH": {
        "PLACEHOLDER": "Pretražite članke"
      }
    },
    "CATEGORY": {
      "ADD": {
        "TITLE": "Napravi kategoriju",
        "SUB_TITLE": "Kategorija će se koristiti u javno dostupnim portalima da bi se članci kategorizovali.",
        "PORTAL": "Portal",
        "LOCALE": "Lokal",
        "NAME": {
          "LABEL": "Ime",
          "PLACEHOLDER": "Naziv kategorije",
          "HELP_TEXT": "Naziv kategorije i ikonica će se koristiti u javno dostupnom portalu za kategorizaciju članaka.",
          "ERROR": "Ime je neophodno"
        },
        "SLUG": {
          "LABEL": "Slug",
          "PLACEHOLDER": "Slug kategorije za adrese",
          "HELP_TEXT": "chat.jarabot.com/hc/my-portal/en-US/categories/my-slug",
          "ERROR": "Slug je obavezan"
        },
        "DESCRIPTION": {
          "LABEL": "Opis",
          "PLACEHOLDER": "Dostavite kratak opis kategorije.",
          "ERROR": "Opis je neophodan"
        },
        "BUTTONS": {
          "CREATE": "Napravi kategoriju",
          "CANCEL": "Otkaži"
        },
        "API": {
          "SUCCESS_MESSAGE": "Kategorija je uspešno napravljena",
          "ERROR_MESSAGE": "Nije bilo moguće napraviti kategoriju"
        }
      },
      "EDIT": {
        "TITLE": "Izmeni kategoriju",
        "SUB_TITLE": "Izmena kategorije će ažurirati kategoriju u javno dostupnom portalu.",
        "PORTAL": "Portal",
        "LOCALE": "Lokal",
        "NAME": {
          "LABEL": "Ime",
          "PLACEHOLDER": "Naziv kategorije",
          "HELP_TEXT": "Naziv kategorije i ikonica će se koristiti u javno dostupnom portalu za kategorizaciju članaka.",
          "ERROR": "Ime je neophodno"
        },
        "SLUG": {
          "LABEL": "Slug",
          "PLACEHOLDER": "Slug kategorije za adrese",
          "HELP_TEXT": "chat.jarabot.com/hc/my-portal/en-US/categories/my-slug",
          "ERROR": "Slug je obavezan"
        },
        "DESCRIPTION": {
          "LABEL": "Opis",
          "PLACEHOLDER": "Dostavite kratak opis kategorije.",
          "ERROR": "Opis je neophodan"
        },
        "BUTTONS": {
          "CREATE": "Ažuriraj kategoriju",
          "CANCEL": "Otkaži"
        },
        "API": {
          "SUCCESS_MESSAGE": "Kategorija je uspešno ažurirana",
          "ERROR_MESSAGE": "Kategoriju nije moguće ažurirati"
        }
      },
      "DELETE": {
        "API": {
          "SUCCESS_MESSAGE": "Kategorija je uspešno obrisana",
          "ERROR_MESSAGE": "Kategoriju nije moguće obrisati"
        }
      }
    },
    "ARTICLE_SEARCH": {
      "TITLE": "Pretraži članke",
      "PLACEHOLDER": "Pretraži članke",
      "NO_RESULT": "Članci nisu pronađeni",
      "SEARCHING": "Pretraga...",
      "SEARCH_BUTTON": "Traži",
      "INSERT_ARTICLE": "Umetni link",
      "IFRAME_ERROR": "URL je prazan ili nevažeći. Sadržaj nije moguće prikazati.",
      "OPEN_ARTICLE_SEARCH": "Umetni članak iz centra za pomoć",
      "SUCCESS_ARTICLE_INSERTED": "Članak je uspešno umetnut",
      "PREVIEW_LINK": "Pregledaj članak",
      "CANCEL": "Zatvori",
      "BACK": "Nazad",
      "BACK_RESULTS": "Nazad na rezultate"
    },
    "UPGRADE_PAGE": {
      "TITLE": "Centar za pomoć",
      "DESCRIPTION": "Kreirajte jednostavne portale za samostalnu podršku. Pomozite korisnicima da pristupe člancima i dobiju podršku 24/7. Nadogradite pretplatu da biste omogućili ovu funkciju.",
      "SELF_HOSTED_DESCRIPTION": "Kreirajte jednostavne portale za samostalnu podršku. Pomozite korisnicima da pristupe člancima i dobiju podršku 24/7. Obratite se administratoru da biste omogućili ovu funkciju.",
      "BUTTON": {
        "LEARN_MORE": "Saznajte više",
        "UPGRADE": "Nadogradi"
      },
      "FEATURES": {
        "PORTALS": {
          "TITLE": "Više portala",
          "DESCRIPTION": "Kreirajte više portala centra za pomoć za različite proizvode koristeći isti nalog."
        },
        "LOCALES": {
          "TITLE": "Puna podrška za lokale",
          "DESCRIPTION": "Lokalizujte portal na svom jeziku. Podržavamo sve lokale i omogućavamo prevode za svaki članak."
        },
        "SEO": {
          "TITLE": "SEO prilagođen dizajn",
          "DESCRIPTION": "Prilagodite svoje meta oznake da biste poboljšali vidljivost na pretraživačima uz naše SEO prilagođene stranice."
        },
        "API": {
          "TITLE": "Puna API podrška",
          "DESCRIPTION": "Koristite portal kao headless CMS sa front-end okvirima trećih strana putem naših API-ja."
        }
      }
    },
    "LOADING": "Učitavanje...",
    "ARTICLES_PAGE": {
      "ARTICLE_CARD": {
        "CARD": {
          "VIEWS": "{count} pregled | {count} pregleda",
          "DROPDOWN_MENU": {
            "PUBLISH": "Objavite",
            "DRAFT": "Draft",
            "ARCHIVE": "Arhiviraj",
            "DELETE": "Izbriši"
          },
          "STATUS": {
            "DRAFT": "Draft",
            "PUBLISHED": "Objavljeno",
            "ARCHIVED": "Arhivirano"
          },
          "CATEGORY": {
            "UNCATEGORISED": "Nekategorisano"
          }
        }
      },
      "ARTICLES_HEADER": {
        "TABS": {
          "ALL": "Svi članci",
          "MINE": "Moji",
          "DRAFT": "Draft",
          "PUBLISHED": "Objavljeno",
          "ARCHIVED": "Arhivirano"
        },
        "CATEGORY": {
          "ALL": "Sve kategorije"
        },
        "LOCALE": {
          "ALL": "Svi lokali"
        },
        "NEW_ARTICLE": "Novi članak"
      },
      "EMPTY_STATE": {
        "ALL": {
          "TITLE": "Napišite članak",
          "SUBTITLE": "Napišite sadržajan članak, počnimo!",
          "BUTTON_LABEL": "Novi članak"
        },
        "MINE": {
          "TITLE": "Ovde još niste napisali nijedan članak",
          "SUBTITLE": "Svi članci koje ste napisali prikazuju se ovde radi brzog pristupa."
        },
        "DRAFT": {
          "TITLE": "Nema članaka u Draft stanju",
          "SUBTITLE": "Draft članci će se ovde prikazati"
        },
        "PUBLISHED": {
          "TITLE": "Nema objavljenih članaka",
          "SUBTITLE": "Objavljeni članci će se ovde prikazati"
        },
        "ARCHIVED": {
          "TITLE": "Nema članaka u arhivi",
          "SUBTITLE": "Arhivirani članci se ne prikazuju na portalu, možete ih koristiti za obeležavanje zastarelih stranica"
        },
        "CATEGORY": {
          "TITLE": "Nema članaka u ovoj kategoriji",
          "SUBTITLE": "Članci iz ove kategorije će se ovde prikazati"
        }
      }
    },
    "CATEGORY_PAGE": {
      "CATEGORY_HEADER": {
        "NEW_CATEGORY": "Nova kategorija",
        "EDIT_CATEGORY": "Izmeni kategoriju",
        "CATEGORIES_COUNT": "{n} kategorija | {n} kategorija",
        "BREADCRUMB": {
          "CATEGORY_LOCALE": "Kategorije ({localeCode})",
          "ACTIVE_CATEGORY": "{categoryName} ({categoryCount} članaka) | {categoryName} ({categoryCount} članak)"
        }
      },
      "CATEGORY_EMPTY_STATE": {
        "TITLE": "Nije pronađena nijedna kategorija",
        "SUBTITLE": "Kategorije će se ovde prikazati. Kategoriju možete dodati klikom na dugme 'Nova kategorija'."
      },
      "CATEGORY_CARD": {
        "ARTICLES_COUNT": "{count} članak | {count} članaka",
        "EXPAND": "Prikaži podkategorije",
        "COLLAPSE": "Sakrij podkategorije",
        "MENU": {
          "NEW_ARTICLE": "Novi članak",
          "ADD_SUBCATEGORY": "Dodaj podkategoriju",
          "EDIT": "Izmeni",
          "DELETE": "Obriši"
        }
      },
      "CATEGORY_DIALOG": {
        "CREATE": {
          "API": {
            "SUCCESS_MESSAGE": "Kategorija je uspešno napravljena",
            "ERROR_MESSAGE": "Nije bilo moguće napraviti kategoriju"
          }
        },
        "EDIT": {
          "API": {
            "SUCCESS_MESSAGE": "Kategorija je uspešno ažurirana",
            "ERROR_MESSAGE": "Kategoriju nije moguće ažurirati"
          }
        },
        "DELETE": {
          "API": {
            "SUCCESS_MESSAGE": "Kategorija je uspešno obrisana",
            "ERROR_MESSAGE": "Kategoriju nije moguće obrisati"
          },
          "CONFIRM": {
            "TITLE": "Obriši kategoriju",
            "DESCRIPTION": "Da li ste sigurni da želite da obrišete ovu kategoriju? Njeni članci će postati nekategorisani.",
            "DESCRIPTION_WITH_CHILDREN": "Da li ste sigurni da želite da obrišete ovu kategoriju? Njeni članci će postati nekategorisani, a njena {count} podkategorija će biti premeštena na najviši nivo. | Da li ste sigurni da želite da obrišete ovu kategoriju? Njeni članci će postati nekategorisani, a njenih {count} podkategorija će biti premešteno na najviši nivo.",
            "CONFIRM": "Obriši"
          }
        },
        "HEADER": {
          "CREATE": "Napravi kategoriju",
          "EDIT": "Izmeni kategoriju",
          "DESCRIPTION": "Izmena kategorije će ažurirati kategoriju u javno dostupnom portalu.",
          "PORTAL": "Portal",
          "LOCALE": "Lokal"
        },
        "FORM": {
          "NAME": {
            "LABEL": "Ime",
            "PLACEHOLDER": "Naziv kategorije",
            "ERROR": "Ime je neophodno"
          },
          "SLUG": {
            "LABEL": "Slug",
            "PLACEHOLDER": "Slug kategorije za adrese",
            "ERROR": "Slug je obavezan",
            "HELP_TEXT": "chat.jarabot.com/hc/{portalSlug}/{localeCode}/categories/{categorySlug}"
          },
          "DESCRIPTION": {
            "LABEL": "Opis",
            "PLACEHOLDER": "Dostavite kratak opis kategorije.",
            "ERROR": "Opis je neophodan"
          },
          "PARENT_CATEGORY": {
            "LABEL": "Nadređena kategorija",
            "PLACEHOLDER": "Izaberite nadređenu kategoriju",
            "NONE": "Nijedna (najviši nivo)"
          }
        },
        "BUTTONS": {
          "CREATE": "Napravi",
          "EDIT": "Ažuriraj",
          "CANCEL": "Otkaži"
        }
      }
    },
    "LOCALES_PAGE": {
      "LOCALES_COUNT": "Nema dostupnih lokala | {n} lokal | {n} lokala",
      "NEW_LOCALE_BUTTON_TEXT": "Novi lokal",
      "LOCALE_CARD": {
        "ARTICLES_COUNT": "{count} članak | {count} članaka",
        "CATEGORIES_COUNT": "{count} kategorija | {count} kategorija",
        "DEFAULT": "Predefinisano",
        "DROPDOWN_MENU": {
          "MAKE_DEFAULT": "Postavi kao podrazumevano",
          "DELETE": "Izbriši"
        }
      },
      "ADD_LOCALE_DIALOG": {
        "TITLE": "Dodaj novi lokal",
        "DESCRIPTION": "Izaberite jezik na kom će ovaj članak biti napisan. Biće dodat na vašu listu prevoda, a kasnije možete dodati još.",
        "COMBOBOX": {
          "PLACEHOLDER": "Izaberi lokal..."
        },
        "API": {
          "SUCCESS_MESSAGE": "Lokal je uspešno dodat",
          "ERROR_MESSAGE": "Lokal nije moguće dodati. Pokušajte ponovo."
        }
      }
    },
    "EDIT_ARTICLE_PAGE": {
      "HEADER": {
        "STATUS": {
          "SAVING": "Čuvanje...",
          "SAVED": "Sačuvano"
        },
        "PREVIEW": "Pregledajte",
        "PUBLISH": "Objavite",
        "DRAFT": "Draft",
        "ARCHIVE": "Arhiviraj",
        "BACK_TO_ARTICLES": "Nazad na članke"
      },
      "DRAFT": {
        "PENDING_LABEL": "Neobjavljene izmene",
        "PROMOTE": "Objavi izmene",
        "DISCARD": "Odbaci izmene",
        "PROMOTE_SUCCESS": "Draft izmene su objavljene u aktivnom članku",
        "PROMOTE_ERROR": "Nije moguće objaviti Draft izmene",
        "DISCARD_SUCCESS": "Draft izmene su odbačene",
        "DISCARD_ERROR": "Nije moguće odbaciti Draft izmene"
      },
      "VERSION_HISTORY": {
        "MENU_ITEM": "Istorija verzija",
        "TITLE": "Istorija verzija",
        "BACK": "Nazad na članak",
        "LOADING": "Učitavanje verzija...",
        "EMPTY": "Još uvek nema verzija. Izmene ovog članka će se ovde prikazivati.",
        "EMPTY_CONTENT": "Ova verzija nema sadržaj.",
        "CURRENT_BADGE": "Trenutna",
        "RESTORED_BADGE": "Vraćena",
        "AUTOMATED_USER": "Automatsko ažuriranje",
        "RESTORE": "Vrati ovu verziju",
        "RESTORE_DIALOG": {
          "TITLE": "Vratiti ovu verziju?",
          "DESCRIPTION": "Članak će se vratiti na tekst ove verzije. Ništa se ne gubi — trenutni tekst ostaje u istoriji, a objavljeni članak i dalje prikazuje aktivnu verziju dok ne objavite izmenu.",
          "CONFIRM": "Vrati"
        },
        "RESTORE_SUCCESS": "Verzija je vraćena",
        "RESTORE_ERROR": "Nije moguće vratiti ovu verziju",
        "FETCH_ERROR": "Nije moguće učitati istoriju verzija"
      },
      "EDIT_ARTICLE": {
        "MORE_PROPERTIES": "Više svojstava",
        "TRANSLATE": "Prevedi",
        "SOURCE": "Markdown",
        "UNCATEGORIZED": "Nekategorisano",
        "EDITOR_PLACEHOLDER": "Napišite nešto...",
        "HTML_EMBED": {
          "TITLE": "Umetni prilagođeni HTML",
          "DESCRIPTION": "Nalepite čist HTML poput iframe-a, embed-a ili isečka vidžeta. Biće prikazan onakav kakav jeste u objavljenom članku.",
          "PLACEHOLDER": "<iframe src=\"https://...\"></iframe>",
          "INSERT": "Umetni"
        },
        "PRIMARY_CATEGORY": "Примарна категорија"
      },
      "ARTICLE_PROPERTIES": {
        "ARTICLE_PROPERTIES": "Svojstva članka",
        "SLUG": "Slug",
        "EDIT_SLUG": "Edit slug",
        "META_DESCRIPTION": "Meta opis",
        "META_DESCRIPTION_PLACEHOLDER": "Dodaj meta opis",
        "META_TITLE": "Meta naslov",
        "META_TITLE_PLACEHOLDER": "Dodaj meta naslov",
        "META_TAGS": "Meta oznake",
        "META_TAGS_PLACEHOLDER": "Dodaj meta oznake",
        "SET_AS_HOMEPAGE": "Set as homepage",
        "SET_AS_HOMEPAGE_HELP": "Show this article as the help center homepage for this language. Add {'{{NAV}}'} in the content to include search + categories.",
        "LANGUAGE_MUTATIONS": "Jezičke varijante",
        "LANGUAGE_MUTATIONS_EMPTY": "Još nema povezanih članaka",
        "ADD_MUTATION": "Dodaj",
        "REMOVE_MUTATION": "Ukloni"
      },
      "LANGUAGE_MUTATIONS_DIALOG": {
        "TITLE": "Poveži jezičke varijante",
        "SEARCH_PLACEHOLDER": "Pretraži članke po naslovu",
        "EMPTY": "Nema podudarnih članaka",
        "CANCEL": "Otkaži",
        "ADD_SELECTED": "Dodaj izabrane",
        "SUCCESS": "Varijante ažurirane",
        "ERROR": "Ažuriranje varijanti nije uspelo"
      },
      "TRANSLATE_DIALOG": {
        "TITLE": "Prevedi članak",
        "DESCRIPTION": "Izaberite jezike na koje želite da prevedete ovaj članak. Jezici koji su već prevedeni biće ponovo prevedeni u Draft radi provere.",
        "EMPTY": "Nijedan drugi jezik nije dostupan.",
        "CONNECTED_BADGE": "Prevedeno",
        "CANCEL": "Otkaži",
        "TRANSLATE": "Prevedi",
        "SUCCESS": "Prevođenje će uskoro početi. Prevedeni članci će se uskoro pojaviti kao jezičke varijante.",
        "ERROR": "Pokretanje prevođenja nije uspelo"
      },
      "SLUG_DIALOG": {
        "TITLE": "Edit article URL",
        "DESCRIPTION": "Change the descriptive part of this article's slug. Old links keep working — they redirect here automatically.",
        "INPUT_LABEL": "Slug",
        "PLACEHOLDER": "getting-started",
        "PREFIX_HINT": "The numeric prefix is a permanent identifier and cannot be changed.",
        "PREVIEW": "Article URL",
        "CANCEL": "Cancel",
        "SAVE": "Save",
        "SUCCESS": "Article URL updated",
        "ERROR": "Failed to update the article URL"
      },
      "API": {
        "ERROR": "Greška prilikom čuvanja članka"
      }
    },
    "PORTAL_SWITCHER": {
      "NEW_PORTAL": "Novi portal",
      "PORTALS": "Portali",
      "CREATE_PORTAL": "Kreirajte i upravljajte sa više portala",
      "ARTICLES": "članci",
      "DOMAIN": "domen",
      "PORTAL_NAME": "Naziv portala"
    },
    "CREATE_PORTAL_DIALOG": {
      "TITLE": "Kreiraj novi portal",
      "DESCRIPTION": "Dajte naziv svom portalu i kreirajte razumljiv URL slug. Oboje kasnije možete izmeniti u podešavanjima.",
      "CONFIRM_BUTTON_LABEL": "Napravi",
      "NAME": {
        "LABEL": "Ime",
        "PLACEHOLDER": "Korisnički vodič",
        "MESSAGE": "Izaberite naziv za svoj portal.",
        "ERROR": "Ime je neophodno"
      },
      "SLUG": {
        "LABEL": "Slug",
        "PLACEHOLDER": "user-guide",
        "ERROR": "Slug je obavezan",
        "FORMAT_ERROR": "Koristite samo slova, brojeve i crtice, na primer: user-guide"
      }
    },
    "PORTAL_SETTINGS": {
      "FORM": {
        "AVATAR": {
          "LABEL": "Logo",
          "IMAGE_UPLOAD_ERROR": "Sliku nije moguće otpremiti! Pokušajte ponovo",
          "IMAGE_UPLOAD_SUCCESS": "Slika je uspešno dodata. Kliknite na 'Sačuvaj izmene' da biste sačuvali logo",
          "IMAGE_DELETE_SUCCESS": "Logo je uspešno obrisan",
          "IMAGE_DELETE_ERROR": "Logo nije moguće obrisati",
          "IMAGE_UPLOAD_SIZE_ERROR": "Veličina slike treba da bude manja od {size}MB"
        },
        "HERO_IMAGE": {
          "LABEL": "Hero image",
          "HELP_TEXT": "Optional full-width background image shown behind the centered search box on the help center homepage.",
          "IMAGE_UPLOAD_ERROR": "Couldn't upload image! Try again",
          "IMAGE_UPLOAD_SUCCESS": "Image added successfully. Please click on save changes to save the hero image",
          "IMAGE_DELETE_SUCCESS": "Hero image deleted successfully",
          "IMAGE_DELETE_ERROR": "Unable to delete hero image",
          "IMAGE_UPLOAD_SIZE_ERROR": "Image size should be less than {size}MB"
        },
        "HOMEPAGE_ARTICLES": {
          "LABEL": "Homepage articles",
          "EMPTY": "No article is set as the homepage. Set one from an article's properties.",
          "HELP_TEXT": "The article shown as the homepage for each language. Click to open it, or remove to restore the default homepage.",
          "REMOVE": "Remove",
          "REMOVE_SUCCESS": "Homepage article removed",
          "REMOVE_ERROR": "Unable to remove homepage article"
        },
        "NAME": {
          "LABEL": "Ime",
          "PLACEHOLDER": "Naziv portala",
          "ERROR": "Ime je neophodno"
        },
        "HEADER_TEXT": {
          "LABEL": "Tekst zaglavlja",
          "PLACEHOLDER": "Tekst zaglavlja portala"
        },
        "PAGE_TITLE": {
          "LABEL": "Naslov stranice",
          "PLACEHOLDER": "Naslov stranice portala"
        },
        "HOME_PAGE_LINK": {
          "LABEL": "Link početne stranice",
          "PLACEHOLDER": "Veza do početne stranice portala",
          "ERROR": "Nevažeći URL. Link početne stranice mora počinjati sa 'http://' ili 'https://'."
        },
        "SLUG": {
          "LABEL": "Slug",
          "PLACEHOLDER": "Slug portala"
        },
        "LIVE_CHAT_WIDGET": {
          "LABEL": "Vidžet za ćaskanje uživo",
          "PLACEHOLDER": "Izaberite vidžet za ćaskanje uživo",
          "HELP_TEXT": "Izaberite vidžet za ćaskanje uživo koji će se prikazati na vašem centru za pomoć"
        },
        "PUBLIC_ACCESS": {
          "LABEL": "Javno dostupno",
          "HELP_TEXT": "Učinite portal dostupnim svima sa linkom.",
          "OPTIONS": {
            "PUBLIC": "Da",
            "PRIVATE": "Ne"
          }
        },
        "LINK_TARGET": {
          "LABEL": "Odredište veze",
          "HELP_TEXT": "Odaberite da li se veze unutar članaka otvaraju u trenutnom prozoru ili u novom.",
          "OPTIONS": {
            "CURRENT_WINDOW": "Trenutni prozor",
            "NEW_WINDOW": "Novi prozor"
          }
        },
        "DEFAULT_IMAGE_SIZE": {
          "LABEL": "Podrazumevana veličina slike",
          "HELP_TEXT": "Veličina koja se primenjuje na svaku sliku koju umetnete u članak. Izaberite Original da umetnete slike u njihovoj sopstvenoj veličini, ili birajte veličinu za svaku sliku posebno."
        },
        "BRAND_COLOR": {
          "LABEL": "Boja brenda"
        },
        "CUSTOM_HTML": {
          "LABEL": "Prilagođeni HTML",
          "PLACEHOLDER": "<!-- Nalepite ovde svoj analitički ili prateći kod -->",
          "HELP_TEXT": "Umeće se na početku <body> oznake na svakoj stranici centra za pomoć. Koristite ga za Google Analytics, Google Tag Manager ili bilo koji drugi kod za praćenje. Kod se prikazuje tačno onako kako je unet i ne proverava se."
        },
        "SAVE_CHANGES": "Sačuvaj izmene"
      },
      "CONFIGURATION_FORM": {
        "CUSTOM_DOMAIN": {
          "HEADER": "Prilagođeni domen",
          "LABEL": "Prilagođeni domen:",
          "DESCRIPTION": "Portal možete hostovati na prilagođenom domenu. Na primer, ako je vaš sajt yourdomain.com i želite da vaš portal bude dostupan na docs.yourdomain.com, jednostavno unesite to u ovo polje.",
          "PLACEHOLDER": "Prilagođeni domen portala",
          "EDIT_BUTTON": "Izmeni prilagođeni domen",
          "ADD_BUTTON": "Dodaj prilagođeni domen",
          "DIALOG": {
            "ADD_HEADER": "Dodaj prilagođeni domen",
            "EDIT_HEADER": "Izmeni prilagođeni domen",
            "ADD_CONFIRM_BUTTON_LABEL": "Dodaj domen",
            "EDIT_CONFIRM_BUTTON_LABEL": "Ažuriraj domen",
            "LABEL": "Prilagođeni domen",
            "PLACEHOLDER": "Prilagođeni domen portala",
            "ERROR": "Prilagođeni domen je obavezan"
          },
          "DNS_CONFIGURATION_DIALOG": {
            "HEADER": "DNS konfiguracija",
            "DESCRIPTION": "Prijavite se na nalog kod svog DNS provajdera i dodajte CNAME zapis ispod za svoj poddomen.",
            "HELP_TEXT": "Kada to završite, možete se obratiti našoj podršci da zatražite automatski generisan SSL sertifikat.",
            "CONFIRM_BUTTON_LABEL": "Razumem!"
          }
        },
        "DELETE_PORTAL": {
          "BUTTON": "Obriši {portalName}",
          "HEADER": "Obriši portal",
          "DESCRIPTION": "Trajno obrišite ovaj portal. Ova akcija je nepovratna",
          "DIALOG": {
            "HEADER": "Sigurni ste da želite da obrišete {portalName}?",
            "DESCRIPTION": "Ovo je trajna akcija koja se ne može poništiti.",
            "CONFIRM_BUTTON_LABEL": "Izbriši"
          }
        },
        "EDIT_CONFIGURATION": "Izmeni konfiguraciju"
      },
      "API": {
        "CREATE_PORTAL": {
          "SUCCESS_MESSAGE": "Portal je uspešno napravljen",
          "ERROR_MESSAGE": "Portal nije moguće kreirati"
        },
        "UPDATE_PORTAL": {
          "SUCCESS_MESSAGE": "Portal je uspešno ažuriran",
          "ERROR_MESSAGE": "Portal nije moguće ažurirati"
        }
      }
    },
    "ATTACHMENTS": {
      "TITLE": "Prilozi",
      "DRAFT_BADGE": "Draft",
      "ADD_BUTTON": "Dodaj fajl",
      "DROP_HERE": "Prevucite i otpustite fajlove ovde",
      "COPY_LINK": "Kopiraj link",
      "LINK_COPIED": "Link je kopiran u privremenu memoriju",
      "COPY_FAILED": "Kopiranje linka nije uspelo",
      "DELETE": "Obriši",
      "CANCEL": "Otkaži",
      "QUEUED": "U redu čekanja",
      "UPLOADING": "Otpremanje",
      "UPLOAD_FAILED": "Otpremanje fajla nije uspelo",
      "FILE_TOO_LARGE": "Fajl prelazi ograničenje veličine od 40 MB"
    },
    "DICTIONARY_PAGE": {
      "HEADER": {
        "TITLE": "Rečnik prevoda",
        "DESCRIPTION": "Termini definisani ovde se dodaju u AI upit za prevod kako bi uvek bili prevedeni na isti način. Ključni termin je napisan na {locale}."
      },
      "NEW_TERM": "Novi termin",
      "EMPTY_STATE": {
        "TITLE": "Još uvek nema termina u rečniku",
        "SUBTITLE": "Dodajte termin i njegov prevod za svaki jezik. Kada se članak prevede, ovi termini se primenjuju kako bi terminologija vašeg proizvoda ostala dosledna."
      },
      "LIST": {
        "TERM": "Termin",
        "TRANSLATIONS": "Prevodi",
        "ACTIONS": "Radnje"
      },
      "DICTIONARY_DIALOG": {
        "HEADER": {
          "CREATE": "Dodaj termin",
          "EDIT": "Izmeni termin",
          "DESCRIPTION": "Termin ispod se primenjuje prilikom AI prevoda članaka vašeg centra za pomoć.",
          "PORTAL": "Portal",
          "PRIMARY_LANGUAGE": "Primarni jezik"
        },
        "FORM": {
          "TERM": {
            "LABEL": "Termin ({locale})",
            "PLACEHOLDER": "Inbox",
            "ERROR": "Termin je obavezan"
          },
          "DESCRIPTION": {
            "LABEL": "Kontekst / napomene (opcionalno)",
            "PLACEHOLDER": "Kada i kako se ovaj termin koristi, kako bi se prevodiocu pomoglo da razjasni značenje."
          },
          "TRANSLATIONS": "Prevodi",
          "TRANSLATION_PLACEHOLDER": "Ostavite prazno da bi AI slobodno preveo",
          "AUTO_TRANSLATE": {
            "BUTTON": "Automatski prevedi sve",
            "CONFIRM": "Prevesti na {count} jezika uz pomoć AI-ja?",
            "CONFIRM_BUTTON": "Prevedi",
            "CANCEL": "Otkaži",
            "SUCCESS": "Prevodi su generisani — pregledajte i sačuvajte",
            "ERROR": "Nije bilo moguće automatski prevesti, molim vas pokušajte ponovo"
          }
        },
        "BUTTONS": {
          "CREATE": "Dodaj termin",
          "EDIT": "Sačuvaj",
          "CANCEL": "Otkaži"
        },
        "CREATE": {
          "API": {
            "SUCCESS_MESSAGE": "Termin je uspešno dodat",
            "ERROR_MESSAGE": "Nije bilo moguće dodati termin. Molim vas pokušajte ponovo"
          }
        },
        "EDIT": {
          "API": {
            "SUCCESS_MESSAGE": "Termin je uspešno izmenjen",
            "ERROR_MESSAGE": "Nije bilo moguće izmeniti termin. Molim vas pokušajte ponovo"
          }
        }
      },
      "DELETE": {
        "CONFIRM": {
          "TITLE": "Obriši termin",
          "DESCRIPTION": "Da li ste sigurni da želite da obrišete ovaj termin? Više neće biti primenjivan prilikom prevoda.",
          "CONFIRM": "Obriši"
        },
        "API": {
          "SUCCESS_MESSAGE": "Termin je uspešno obrisan",
          "ERROR_MESSAGE": "Nije bilo moguće obrisati termin. Molim vas pokušajte ponovo"
        }
      }
    }
  }
}
